/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

const IconEmail = () => (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" xmlSpace="preserve">
    <path style={{ fill: 'none', stroke: '#646464', strokeMiterlimit: 10 }} d="M16.9,15.5H2.8c-1.1,0-1.9-0.9-1.9-1.9V2.4c0-1.1,0.9-1.9,1.9-1.9h14.1c1.1,0,1.9,0.9,1.9,1.9v11.1C18.9,14.6,18,15.5,16.9,15.5z" />
    <g style={{ display: 'none' }}>
      <path style={{ display: 'inline', fill: '#646464' }} d="M16.6,3.3v1.2c0,0.1,0,0.1-0.1,0.2c-0.8,0.5-6.2,4.1-6.5,4.1S4.3,5.2,3.5,4.7c-0.1,0-0.1-0.1-0.1-0.2V3.3c0-0.1,0.1-0.2,0.2-0.2c0,0,0.1,0,0.1,0C5,4,9.5,7.2,10,7.2s5-3.1,6.3-4c0.1-0.1,0.2,0,0.3,0.1C16.6,3.2,16.6,3.3,16.6,3.3z" />
    </g>
    <polyline style={{ fill: 'none', stroke: '#646464', strokeWidth: 1.15, strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: 10 }} points="3.4,3.9 9.9,8 16.6,3.9 	" />
  </svg>
);
IconEmail.propTypes = {};

export default IconEmail;
